import { useTranslations } from "use-intl";
import { Measurement } from "@/gql/graphql";

const KM_TO_MILES = 0.621371;

function calculateSuggestedHireUnits(durationHrs: number): number {
  return Math.max(2, Math.ceil(durationHrs / 4));
}

export function TripStats({
  distance_kms,
  duration_hrs,
  route_name,
  measurement = Measurement.Metric,
}: {
  distance_kms?: number | null;
  duration_hrs?: number | null;
  route_name?: string | null;
  measurement?: Measurement;
}) {
  const t = useTranslations("relocation");

  const isImperial = measurement === Measurement.Imperial;

  const distanceValue =
    distance_kms != null
      ? isImperial
        ? Math.round(distance_kms * KM_TO_MILES)
        : distance_kms
      : null;

  const distanceLabel =
    distanceValue != null
      ? `${distanceValue} ${t(`distanceUnit.${measurement}`)}`
      : "N/A";

  const suggestedDays = duration_hrs
    ? calculateSuggestedHireUnits(duration_hrs)
    : null;

  return (
    <div className="bg-gray-50 p-3">
      <div className="flex items-center gap-4">
        {route_name ? (
          <>
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-500">Route:</span>
              <span className="font-semibold text-gray-900">{route_name}</span>
            </div>
            <div className="h-4 w-px bg-gray-300" />
          </>
        ) : null}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">Distance:</span>
          <span className="font-semibold text-gray-900">{distanceLabel}</span>
        </div>
        <div className="h-4 w-px bg-gray-300" />
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">Driving time:</span>
          <span className="font-semibold text-gray-900">
            {duration_hrs
              ? t("trip_duration_hrs", { count: duration_hrs })
              : "N/A"}
          </span>
        </div>
        {suggestedDays ? (
          <>
            <div className="h-4 w-px bg-gray-300" />
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-500">Suggested days:</span>
              <span className="font-semibold text-gray-900">
                {suggestedDays}
              </span>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
